/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Benard Agustin",
  title: "Hi, I'm Benard",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Flutter / Spring-boot / Django and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1PcjvRnys3m0nMwGQMj-z5SlMGpn5quOl/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/benardelia",
  linkedin: "https://www.linkedin.com/in/benard-agustin-360070227/",
  gmail: "agustinbenard2000@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/benard.agustino.9/",
  medium: "https://medium.com/@agustinbenard2000",
  stackoverflow: "https://stackoverflow.com/users/19200372/benard-agustin",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Rust",
      fontAwesomeClassname: "fab fa-rust"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // {
    //   schoolName: "University of Dodoma",
    //   logo: require("./assets/images/udomlogo2.png"),
    //   subHeader: "Masters Degree in software engineering.",
    //   duration: "September 2024 - April 2026",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Publish Doc about Advanced software re-engineering", "Morden Software design with Docker and Kubernetes"]
    // },
    {
      schoolName: "Ruaha Catholic University",
      logo: require("./assets/images/ruculogo.png"),
      subHeader: "Bachelor Degree in Computer Science software engineering.",
      duration: "November 2020 - August 2023",
      desc: "Participated in the various projects.",
      descBullets: [
        "Developed a mobile application designed to assist women in tracking pregnancy and menstrual cycles efficiently.",
        "Designed and developed an interactive video game aimed at enhancing cognitive skills and brain activity in children."
      ]
    }
    
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Mobile Development/Design", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "96%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software developer",
      company: "Ministry of Lands, Housing and Human Settlements Development",
      companylogo: require("./assets/images/emblem.png"),
      date: "Jan 2025 – Present",
      desc: "Develop System for supporting and enhance land aquire and ownership ",
      descBullets: [
        "Evaluated projected requirements, identified challenges and proposed alternatives using research and data.",
        "Developed testable software using agile methodologies to create high-quality deliverable."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "eGA RIDC",
      companylogo: require("./assets/images/ega-logo.png"),
      date: "February 2024 – Jan 2025",
      desc: "Developed and maintained iOS/Android and backend applications.",
      descBullets: [
        "Implemented new features in existing software that resulted increase in user engagement.",
        "Optimized app performance that enhanced best user experience",
        "Developed robust back-end applications using Spring Boot for building scalable micro-services, RESTful APIs and managing data, and securing applications."
      ]
    },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "I was fully involved in a large-scale project, contributing to every aspect of its development",
  projects: [
    {
      image: require("./assets/images/e-ardhi.png"),
      projectName: "e-Ardhi",
      projectDesc: "e-Ardhi is a mobile and web application that allows landowners to access their land records and information from the Ministry of Lands, Housing and Human Settlements Development.",
      footerLink: [
        {
          name: "Web App",
          url: "https://eardhi.lands.go.tz/"
        },
        {
          name: "Android App",
          url: "https://play.google.com/store/apps/details?id=tz.go.gms&hl=en"
        },
        {
          name: "iOS App",
          url: "https://apps.apple.com/tz/app/ebarua/id6479197288"
        }
      ]
    },
    {
      image: require("./assets/images/kakakuona-oxygen.webp"),
      projectName: "Kakakuona Oxygen",
      projectDesc: "Kakakuona Oxygen is a secure chatting application designed to facilitate fast, reliable, and confidential communication.",
      footerLink: [
        {
          name: "Web App",
          url: "https://kakakuona.tz/"
        },
        {
          name: "Android App",
          url: "https://play.google.com/store/apps/details?id=im.oxygen.app"
        },
        {
          name: "iOS App",
          url: "https://apps.apple.com/tz/app/kakakuona-oxygen/id6444258363"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/emblem.png"),
      projectName: "eBarua",
      projectDesc: "e-Barua is a comprehensive digital mailing platform designed to facilitate secure, efficient, and official communication for government employees.",
      footerLink: [
        {
          name: "Android App",
          url: "https://play.google.com/store/apps/details?id=tz.go.gms&hl=en"
        },
        {
          name: "iOS App",
          url: "https://apps.apple.com/tz/app/ebarua/id6479197288"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Data Science: Visualization",
      subtitle:
        "Basic data visualization principles and how to apply them using ggplot2.",
      image: require("./assets/images/Harvard-Logo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1ZDB0B1j08pSty0uzEf0d_xDLEb4dDLBL/view?usp=sharing"
        },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@agustinbenard2000/how-to-update-a-flutter-app-without-asking-users-to-update-ed47fb642429",
      title: "🚀 How to Update a Flutter App Without Asking Users to Update",
      description:
        "Imagine this: You’ve launched your app, users love it, and everything seems perfect. Then, one morning over your tea, you spot a critical bug or think of a small UI tweak."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://www.youtube.com/watch?v=UDMC8uqMOnI"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+255 696 683 636",
  email_address: "agustinbenard2000@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "agustin_benard", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
